import {
    computed,
    type ComputedRef,
    type MaybeRef,
    type Ref,
    toValue,
} from 'vue'

export function useCarouselDotsPage(
    containerOffsetWidth: Ref<number>,
    slideWidth: Ref<number>,
    items: MaybeRef<any[]>,
    current: Ref<number>
): {
    pageCount: ComputedRef<number>
    goToPage: (index: number) => void
    getClassDot: (index: number) => { active: boolean }
} {
    const visibleItemsCount = computed(() => {
        return Math.floor(containerOffsetWidth.value / (slideWidth.value || 1))
    })

    const pageCount = computed(() => {
        return Math.max(toValue(items).length - visibleItemsCount.value + 1, 0)
    })

    const getClassDot = (index: number) => ({
        active: index - 1 === current.value,
    })

    const goToPage = (index: number) => {
        current.value = index - 1
    }

    return {
        pageCount,
        goToPage,
        getClassDot,
    }
}
